import styled from 'styled-components';
export const StyledButtonMarcar = styled.span `
  cursor: pointer;
  display: flex;
  padding: 0px 4px;
  margin: 0 auto 8px auto;
  width: 100px;
  align-items: center;
  align-self: flex-start;
  justify-content: center;
  border-style: solid;
  border-width: 1px;
  color: ${({ theme }) => theme.dropSelectorColor} !important;
  background-color: ${({ theme }) => theme.backgroundColorSecondary} !important;
  font-size: ${(props) => props.theme.xsFontSize};
  height: 18px;
  @media ${(props) => props.theme.device.mobileXL} {
    height: 22px;
  }
`;
